export default __webpack_public_path__ + "static/media/red-3.0eafefa3.svg";